<form
    class="detail-page-card-body padded cerrix-control-sm form-group-styling"
    [formGroup]="parentForm"
    novalidate
>
    @if (thirdParty) {
        @if (thirdParty.Identifier) {
            <div class="detail-page-summary">
                <div class="row">
                    <div class="col-6">
                        <div class="property"><b>{{ "detailMain.idLabel" | t }}</b> {{ thirdParty.Identifier }}</div>
                        <div class="property">
                            <b>{{ "detailMain.nameSummaryLabel" | t }}</b>&nbsp;<span data-uiid="thirdparty-summary-name">{{
                                thirdParty.Name
                            }}</span>
                        </div>
                        <div class="property">
                            <b>{{ "detailMain.nextReviewDateSummaryLabel" | t }}</b> {{ thirdParty.NextReviewDate | dateFormat }}
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="property">
                            <b>{{ "detailMain.lastReviewScoreLabel" | t }}</b> {{ thirdParty.Score.Name }}
                        </div>
                        <div class="property"><b>{{ "detailMain.reviewerSummaryLabel" | t }}</b> {{ thirdParty.ReviewerNames }}</div>
                    </div>
                </div>
            </div>
        }
        @if (parentForm) {
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ "detailMain.generalInformationTitle" | t }}</div>
                <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.nameLabel' | t"
                                        dataUiid="thirdpartydetailmain-name"
                                        formControlName="Name"
                                        identifier="thirdPartyNameInput"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.addressLabel' | t"
                                        dataUiid="thirdpartydetailmain-adress"
                                        formControlName="Address"
                                        identifier="thirdPartyAddressInput"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.cityLabel' | t"
                                        dataUiid="thirdpartydetailmain-city"
                                        identifier="thirdPartyCityInput"
                                        formControlName="City"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="thirdPartyCountryInput">{{ "detailMain.countryLabel" | t }}</label>
                                    <ng-select
                                        data-uiid="thirdpartydetailmain-country"
                                        id="thirdPartyCountryInput"
                                        name="thirdPartyCountryInput"
                                        [items]="sd.Countries"
                                        formControlName="Country"
                                        bindLabel="Value"
                                        bindValue="Key"
                                        [closeOnSelect]="true"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.emailLabel' | t"
                                        dataUiid="thirdpartydetailmain-email"
                                        identifier="thirdPartyEmailInput"
                                        formControlName="Email"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.phoneLabel' | t"
                                        dataUiid="thirdpartydetailmain-phone"
                                        identifier="thirdPartyPhoneInput"
                                        formControlName="Phone"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="thirdPartyWebsiteInput">{{ "detailMain.websiteLabel" | t }}</label>
                                    <cerrix-url-input
                                        dataUiid="thirdpartydetailmain-website"
                                        formControlName="Website"
                                    ></cerrix-url-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textarea
                                        [fieldLabel]="'detailMain.commentLabel' | t"
                                        dataUiid="thirdpartydetailmain-comment"
                                        identifier="thirdPartyCommentInput"
                                        formControlName="Comment"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Right block -->
                        <div class="col-12 col-xl-6 right-block">
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textarea
                                        [fieldLabel]="'detailMain.descriptionLabel' | t"
                                        dataUiid="thirdpartydetailmain-description"
                                        identifier="thirdPartyDescriptionInput"
                                        formControlName="Description"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.leiCodeLabel' | t"
                                        dataUiid="thirdpartydetailmain-leicode"
                                        identifier="thirdPartyLeiCodeInput"
                                        formControlName="LeiCode"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-auto">
                                    <label for="thirdPartyEUInput">{{ "detailMain.euMemberLabel" | t }}</label>
                                    <cerrix-checkbox
                                        data-uiid="thirdpartydetailmain-eumember"
                                        fontsize="0.9em"
                                        formControlName="EUMember"
                                        name="thirdPartyEUInput"
                                    ></cerrix-checkbox>
                                </div>
                                <div class="form-group col">
                                    <label for="DUNSInput">{{ "detailMain.dunsNumberLabel" | t }}</label>
                                    <input
                                        data-uiid="thirdpartydetailmain-duns"
                                        type="number"
                                        class="form-control form-control-sm"
                                        id="DUNSInput"
                                        formControlName="DUNS_Number"
                                        name="DUNSInput"
                                        min="0"
                                        max="1000000000"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.authorizedSignatoryLabel' | t"
                                        dataUiid="thirdpartydetailmain-authorizedsign"
                                        identifier="AuthorizedSignatoryInput"
                                        formControlName="AuthorizedSignatory"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="thirdPartyCocInput">{{ "detailMain.chamberOfCommerceLabel" | t }}</label>
                                    <input
                                        data-uiid="thirdpartydetailmain-coc"
                                        class="form-control form-control-sm"
                                        id="thirdPartyCocInput"
                                        type="number"
                                        formControlName="CocNumber"
                                        name="thirdPartyCocInput"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.vatLabel' | t"
                                        dataUiid="thirdpartydetailmain-tax"
                                        identifier="thirdPartyTaxInput"
                                        formControlName="TaxNumber"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.thirdPartyResponsibleLabel' | t"
                                        dataUiid="thirdpartydetailmain-tpresponsible"
                                        identifier="thirdPartyResponsibleInput"
                                        formControlName="ThirdpartyResponsible"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="InvolvementInput">{{ "detailMain.statusOfInvolvementLabel" | t }}</label>
                                    <cerrix-select
                                        data-uiid="thirdpartydetailmain-statusofinvolvement"
                                        [getDataMethod]="statusOfInvolvementRequest"
                                        formControlName="StatusOfInvolvementID"
                                        id="StatusOfInvolvementID"
                                        [closeOnSelect]="true"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                            <!-- Services -->
                            <div class="row">
                                <div class="form-group col">
                                    <label for="Services">{{ "detailMain.servicesLabel" | t }}</label>
                                    <cerrix-select-tree
                                        data-uiid="thirdpartydetailmain-services"
                                        [getDataMethod]="servicesRequest"
                                        formControlName="LinkedServiceIds"
                                        [multiselect]="true"
                                    >
                                    </cerrix-select-tree>
                                </div>
                            </div>
                            <!-- start + enddate servicing -->
                            <div class="row">
                                <div class="form-group col-6">
                                    <label for="StartDateServicing">{{ "detailMain.startDateServicingLabel" | t }}</label>
                                    <date-input
                                        data-uiid="thirdpartydetailmain-startdate"
                                        formControlName="StartDateServicing"
                                    ></date-input>
                                </div>
                                <div class="form-group col-6">
                                    <label for="EndDateServicing">{{ "detailMain.endDateServicingLabel" | t }}</label>
                                    <date-input
                                        data-uiid="thirdpartydetailmain-enddate"
                                        formControlName="EndDateServicing"
                                    ></date-input>
                                </div>
                            </div>
                            <!-- Relationship -->
                            <div class="row">
                                <div class="form-group col">
                                    <label for="Relationship">{{ "detailMain.relationshipLabel" | t }}</label>
                                    <cerrix-select
                                        #ownersCmp
                                        data-uiid="thirdpartydetailmain-relationship"
                                        id="Relationship"
                                        formControlName="Relationship"
                                        [prettyName]="'detailMain.relationshipLabel' | t"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [getDataMethod]="relationshipRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                            <!-- Criticality -->
                            <div class="row">
                                <div class="form-group col">
                                    <label for="Criticality">{{ "detailMain.criticalityLabel" | t }}</label>
                                    <cerrix-select
                                        #ownersCmp
                                        data-uiid="thirdpartydetailmain-criticality"
                                        id="Criticality"
                                        formControlName="Criticality"
                                        [prettyName]="'detailMain.criticalityLabel' | t"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [getDataMethod]="criticalityRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ "detailMain.internalBusinessTitle" | t }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="row">
                            <div class="form-group col">
                                <label for="orgResponsible">{{ "detailMain.organizationResponsibleLabel" | t }}</label>
                                <cerrix-select-tree
                                    data-uiid="thirdpartydetailmain-organizationresponsible"
                                    [getDataMethod]="organizationRequest"
                                    formControlName="OrganizationResponsibleId"
                                    (valueChange)="organizationResponsibleChanged($event)"
                                    placeholder="Required"
                                    [multiselect]="false"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="orgUserSelect">{{ "detailMain.responsibleLabel" | t }}</label>
                                <ng-select
                                    data-uiid="thirdpartydetailmain-responsible"
                                    [loading]="loadingResponsibles"
                                    id="orgUserSelect"
                                    name="orgUserSelect"
                                    [multiple]="true"
                                    [items]="users"
                                    formControlName="UserResponsibles"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="false"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="form-group col">
                                <label for="orgResponsible">{{ "detailMain.organizationsInUseLabel" | t }}</label>
                                <cerrix-select-tree
                                    data-uiid="thirdpartydetailmain-organizations"
                                    placeholder="Required"
                                    formControlName="Organizations"
                                    [getDataMethod]="organizationMultiRequest"
                                    [multiselect]="true"
                                    (onChangeIds)="organizationsChanged($event)"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 right-block">
                        <div class="row">
                            <div class="form-group col">
                                <label for="OrganizationBeneficialInput">{{
                                    "detailMain.organizationBeneficialOwnerLabel" | t
                                }}</label>
                                <cerrix-select-tree
                                    data-uiid="thirdpartydetailmain-orgbeneficialowner"
                                    [getDataMethod]="organizationRequest"
                                    formControlName="OrganizationBeneficialOwner"
                                    [multiselect]="false"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textfield
                                    [fieldLabel]="'detailMain.beneficialOwnerLabel' | t"
                                    dataUiid="thirdpartydetailmain-beneficialowner"
                                    identifier="BeneficialInput"
                                    formControlName="BeneficialOwner"
                                ></cerrix-textfield>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="form-group col">
                                <label for="businessDimension">{{ "detailMain.businessDimensionsLabel" | t }}</label>
                                <cerrix-select-tree
                                    data-uiid="thirdpartydetailmain-businessdimensions"
                                    [getDataMethod]="businessDimensionsRequest"
                                    formControlName="BusinessDimensions"
                                    [multiselect]="true"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="frameworkDimension">{{ "detailMain.frameworkDimensionsLabel" | t }}</label>
                                <cerrix-select-tree
                                    data-uiid="thirdpartydetailmain-frameworkdimensions"
                                    [getDataMethod]="frameworkDimensionsRequest"
                                    formControlName="FrameworkDimensions"
                                    [multiselect]="true"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ "detailMain.dataManagementRolesTitle" | t }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
                <div class="row">
                    <div class="form-group col">
                        <label for="DatamanagementDCRoleInput">{{ "detailMain.dataControllerLabel" | t }}</label>
                        <cerrix-checkbox
                            data-uiid="thirdpartydetailmain-datacontroller"
                            fontsize="0.9em"
                            formControlName="DataController"
                            name="DatamanagementDCRoleInput"
                        ></cerrix-checkbox>
                    </div>
                    <div class="form-group col">
                        <label for="DatamanagementDPRoleInput">{{ "detailMain.dataProcessorLabel" | t }}</label>
                        <cerrix-checkbox
                            data-uiid="thirdpartydetailmain-dataprocessor"
                            fontsize="0.9em"
                            formControlName="DataProcessor"
                            name="DatamanagementDPRoleInput"
                        ></cerrix-checkbox>
                    </div>
                    <div class="form-group col">
                        <label for="DatamanagementDRRoleInput">{{ "detailMain.dataRecipientLabel" | t }}</label>
                        <cerrix-checkbox
                            data-uiid="thirdpartydetailmain-datarecipient"
                            fontsize="0.9em"
                            formControlName="DataRecipient"
                            name="DatamanagementDRRoleInput"
                        ></cerrix-checkbox>
                    </div>
                    <div class="form-group col">
                        <label for="DatamanagementTPRoleInput">{{ "detailMain.thirdPartyLabel" | t }}</label>
                        <cerrix-checkbox
                            data-uiid="thirdpartydetailmain-thirdparty"
                            fontsize="0.9em"
                            formControlName="ThirdParty"
                            name="DatamanagementTPRoleInput"
                        ></cerrix-checkbox>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (thirdPartyCustomFieldsFormGroup) {
        <!-- Custom fields -->
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ "detailMain.customFieldsTitle" | t }}</div>
            <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                <cerrix-custom-fields-editor
                    [parentForm]="thirdPartyCustomFieldsFormGroup"
                    [customFieldData]="customFieldData"
                    [singleColumn]="false"
                ></cerrix-custom-fields-editor>
            </div>
        </div>
    }

    @if (thirdParty) {
        <thirdparty-contacts [thirdParty]="thirdParty" [canEdit]="permissions.canEdit" #contacts>
        </thirdparty-contacts>

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ "detailMain.reviewInformationTitle" | t }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="row">
                            <div class="form-group col">
                                <label for="reviewerSelect">{{ "detailMain.reviewerLabel" | t }}</label>
                                <ng-select
                                    data-uiid="thirdpartydetailmain-reviewer"
                                    [loading]="loadingReviewers"
                                    id="reviewerSelect"
                                    name="reviewerSelect"
                                    [multiple]="true"
                                    [items]="reviewers"
                                    formControlName="Reviewers"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="false"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="reviewFrequencySelect">{{ "detailMain.reviewFrequencyLabel" | t }}</label>
                                <ng-select
                                    data-uiid="thirdpartydetailmain-reviewfrequency"
                                    id="reviewFrequencySelect"
                                    name="reviewFrequencySelect"
                                    formControlName="ReviewFrequency"
                                    bindLabel="Text"
                                    bindValue="ID"
                                    [items]="frequencies"
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 right-block">
                        <div class="row">
                            <div class="form-group col">
                                <label for="startDate">{{ "detailMain.initialDateLabel" | t }}</label>
                                <date-input
                                    data-uiid="thirdpartydetailmain-initialdate"
                                    formControlName="InitialReviewDate"
                                ></date-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="nextReviewDateInput">{{ "detailMain.nextReviewDateLabel" | t }}</label>
                                <date-input
                                    data-uiid="thirdpartydetailmain-nextreviewdate"
                                    formControlName="NextReviewDate"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <thirdparty-reviews
            [thirdpartyModel]="thirdParty"
            [canReview]="permissions.canReview"
            #reviews
        >
        </thirdparty-reviews>
    }
</form>
